
import { createTheme } from "@mui/material/styles";

const selectionTheme = createTheme({
    palette: {
        mode: "dark",
        background: {
            paper: '#183D3D'
        },
        text: {
            primary: '#fff'
        },
        primary: {
            main: '#619744'
        },
        secondary: {
            main: '#ffffff'
        }
    },
    typography: {
        body1: {
            fontSize: '1rem'
        }
    },
    components: {
        MuiFormLabel: {
            variants: [
                {
                    props: { variant: 'small-label' },
                    style: {
                        fontSize: `0.7rem`
                    },
                },
            ]
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    color: "whitesmoke"
                }
            }
        }
    },
    spacing: 15
})

export default selectionTheme;